import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'craig-assistant-message',
    templateUrl: './assistant-message.component.html',
    styleUrl: './assistant-message.component.less',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssistantMessageComponent {
    @Input() message: string = '';
}
